import { render } from "./BseShow.vue?vue&type=template&id=2865d8fa"
import script from "./BseShow.vue?vue&type=script&lang=js"
export * from "./BseShow.vue?vue&type=script&lang=js"

import "./BseShow.vue?vue&type=style&index=0&id=2865d8fa&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__